import { serverFetch } from "@core/server";

const cards = (path, options) => serverFetch(`sprs/cards${path ? `/${path}` : ""}`, options);

export const fetchSprCards = ({ q, vid, state } = {}) =>
  cards("", { queryParams: { q: q || "", ...(vid ? { vid } : {}), state: state || "all" } });
export const registerSprCards = (bodyData) => cards("", { method: "POST", bodyData });
export const updateSprCard = (id, bodyData) => cards(`${id}`, { method: "PUT", bodyData });
export const blockSprCard = (id) => cards(`${id}/block`, { method: "POST", bodyData: {} });
export const unblockSprCard = (id) => cards(`${id}/unblock`, { method: "POST", bodyData: {} });
export const deleteSprCard = (id) => cards(`${id}`, { method: "DELETE" });
export const fetchSprCardHistory = (id) => cards(`${id}/history`);

export const fetchSprCardVids = () => cards("vids");
export const createSprCardVid = (bodyData) => cards("vids", { method: "POST", bodyData });
export const updateSprCardVid = (vid, bodyData) => cards(`vids/${vid}`, { method: "PUT", bodyData });
export const deleteSprCardVid = (vid) => cards(`vids/${vid}`, { method: "DELETE" });
